<template>
  <span>
    <el-tooltip class="item" effect="dark" :content="$t('admin.userGroups.newUser')" placement="top-end">
      <el-button
        id="btn-new-user"
        v-if="$can(permissions.ADMIN_SETTINGS.INVITE_USER)"
        type="success"
        plain
        @click="dialogVisible = true"
        size="mini"
      >
        {{ $t('admin.userGroups.newUser') }}
      </el-button>
    </el-tooltip>
    <el-dialog
      v-on:open="handleOpenDialog"
      :title="$t('admin.userGroups.newUserTitle')"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      class="dialog-with-cols"
    >
      <div class="singup-form-container" v-if="!user.successfullyCreatedUser">
          <div class="hidden-xs dark-blue-panel hidden-sm-only hidden-xs-only" >
          </div>
          <el-col :lg="24" :md="24" :sm="24" :xs="24" class="login-box">
            <div id="error-message" class="alert alert-danger"></div>
            <el-form :model="form" :rules="formRules" ref="form" class="slidedown slideup" autocomplete="off">
              <el-row>
                  <el-col :lg="12" :md="12" :sm="12" :xs="12" class="form-vertical-item">
                    <el-form-item prop="type">
                        <el-switch
                          v-model="form.type"
                          :inline-prompt=true
                          style="--el-switch-on-color: #13ce66; --el-switch-off-color: #13ce66"
                          active-text="Shipper"
                          inactive-text="Consignee"
                        />
                    </el-form-item>
                  </el-col>
                  <el-col :lg="12" :md="12" :sm="12" :xs="12" class="form-vertical-item">
                    <!-- el-form-item prop="seeInvoices" v-if="!form.type">
                        <el-checkbox
                          v-model="form.seeInvoices"
                        >{{ $t('admin.userGroups.invite.shouldSeeInvoice') }}</el-checkbox>
                    </el-form-item -->
                  </el-col>
                </el-row>
              <el-row>
                <el-col :lg="12" :md="12" :sm="12" :xs="12" class="form-vertical-item">
                    <el-form-item prop="accountCode" :label="$t('admin.userGroups.invite.accountCode')">
                      <autocomplete
                        :model.sync="form.accountCode"
                        :modelAdditional.sync="form.accountCodeAndName"
                        :shipperAccountId="null"
                        labelFieldLastWithDash="number"
                        popperAppendToBody
                        :url="autocompleteUrl"
                        labelField="name"
                        valueField="number"
                        valueFieldAdditional="name"
                        ref="accountCode"
                        id="accountCode"
                        autocomplete="ÑÖcompletes"
                        aria-autocomplete="nonex"
                      />
                    </el-form-item>
                  </el-col>
                <el-col :lg="12" :md="12" :sm="12" :xs="12" class="form-vertical-item">
                    <el-form-item prop="email"  :label="$t('admin.userGroups.invite.email')">
                        <el-input v-model="form.email" id="email-us" class="input-radius" maxlength="100"  :placeholder="$t('admin.userGroups.invite.emailPlaceholder')" autocomplete="address-level4"></el-input>
                    </el-form-item>
              </el-col>
              </el-row>
              <el-row>
                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="form-vertical-item text-align-end">
                  <el-button
                    id="form-refresh-button"
                    @click="resetForm"
                    size="mini"
                  >
                    {{ $t('admin.settings.sage.reset') }}
                  </el-button>
                  <el-button
                  type="primary"
                  id="btn-submit"
                  size="mini"
                  @click="submitSignUpForm()" >
                      {{ $t('admin.userGroups.invite.generate') }}
                  </el-button>
              </el-col>
              </el-row>
            </el-form>
          </el-col>
        </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import accountService from '@/api/accountService';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  name: 'GenerateInvitation',
  components: {
    Autocomplete
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    autocompleteUrl() {
      return this.form.type ? apiConstants.END_POINTS.ACCOUNTS.SHIPPERS : apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE;
    }
  },
  watch: {
    'form.accountCode': function accountCodeChange(val) {
      if (val) {
        this.$refs.form.validateField('accountCode');
      }
    },
    'form.type': function typeChange() {
      this.$refs.accountCode.clearLocalModel();
    },
    dialogVisible() {
      this.resetForm();
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        accountCode: '',
        email: '',
        type: true,
        seeInvoices: false,
      },
      formRules: {
        email: [
          { required: true, message: this.$t('signUp.errors.emailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('signUp.errors.emailValid'), trigger: 'blur' }
        ],
        accountCode: [
          { required: true, message: this.$t('signUp.errors.accountCode'), trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      setTimeout(this.resetForm(), 5000);
    },
    handleCloseDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.$el.querySelector(':enabled:first-child').focus();
        this.$refs.form.resetFields();
        this.$refs.accountCode.clearLocalModel();
      } else {
        const interval = setInterval(() => {
          if (this.$refs.form) {
            this.$refs.form.$el.querySelector(':enabled:first-child').focus();
            this.$refs.form.resetFields();
            this.$refs.accountCode.clearLocalModel();
            clearInterval(interval);
          }
        }, 50);
      }
    },
    submitSignUpForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              const response = await accountService.generateInvitation({
                accountNumber: this.form.accountCode,
                email: this.form.email,
                type: this.form.type ? 'shipper' : 'consignee',
                seeInvoices: this.form.seeInvoices
              });
              this.dialogVisible = false;
              this.resetForm();
              this.$message.success(this.$t('admin.userGroups.newUserSuccess'));
              resolve(response);
            } catch (error) {
              resolve(error);
            }
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.loading-group {
  z-index: 9999 !important;
}
</style>
